"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  px: 4,
  mx: 'auto',
  maxW: {
    base: 'container.base',
    tablet: 'container.tablet',
    desktop: 'container.desktop'
  }
};
var _default = exports["default"] = styles;